import { connect } from "react-redux";
import { Redirect } from "react-router-dom";
import { InstrumentedRoute } from "../utils/faro";
import { setLoginUserFromCookie } from "../modules/login/actions";
import { useState } from "react";
import Loader from "../components/Loader";

const PrivateRoute = ({
  component: Component,
  loginUser,
  userCookie,
  setLoginUserFromCookie,
  fallbackUrl,
  ...rest
}) => {
  const [isLoading, setIsLoading] = useState(false);

  if (userCookie && !loginUser && !isLoading) {
    setIsLoading(true);
    setLoginUserFromCookie()
      .then(() => setIsLoading(false))
      .catch(() => setIsLoading(false));
  }

  if (isLoading) {
    return <Loader />;
  }

  return (
    <InstrumentedRoute
      {...rest}
      render={(props) => {
        if (!userCookie || (userCookie && !loginUser)) {
          const redirectTo
            = typeof fallbackUrl === "function"
              ? fallbackUrl(props.match.params)
              : fallbackUrl || "/";
          return <Redirect to={redirectTo} />;
        }
        return <Component {...props} />;
      }}
    />
  );
};

const mapStateToProps = (state) => {
  return {
    loginUser: state.login.loginUser,
  };
};

export default connect(mapStateToProps, {
  setLoginUserFromCookie,
})(PrivateRoute);
